module.exports = {
  BASE_URL: "https://teach.socm.school",
};
//1